"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffluentSpreaderHelper = exports.zeroMappers = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const helpers_1 = require("@turf/helpers");
const turf_1 = require("@turf/turf");
const effluentAreaCalculation_1 = require("./effluentAreaCalculation");
const Definitions_1 = require("../../Definitions");
const getKeyWithMaxValue = (map) => [...map.entries()].reduce((max, curr) => (curr[1] > max[1] ? curr : max))[0];
const zeroMappers = (sectorSegments, segments) => {
    let zeroMapper = new Map();
    for (let i = 0; i < segments; i++) {
        let increment = 0;
        if (sectorSegments[(i + segments - 1) % segments] === 1 && sectorSegments[i] === 0) {
            // find length until not zero;
            while (sectorSegments[(i + increment) % segments] === 0) {
                increment++;
            }
            if (increment > 0) {
                zeroMapper.set(i, increment);
                i = i + increment;
            }
        }
    }
    return zeroMapper;
};
exports.zeroMappers = zeroMappers;
/**
 * @deprecated  Will need to consider if this needs to be a class at all, since it doesn't store any information....
 */
class EffluentSpreaderHelper {
}
exports.EffluentSpreaderHelper = EffluentSpreaderHelper;
EffluentSpreaderHelper.DISTANCE_PADDING_FACTOR = 1.2;
EffluentSpreaderHelper.convertPositionToTurf = (points, closeLoop = true) => {
    let converted = points.map((point) => [point.lng, point.lat]);
    const last = converted.at(-1);
    if (closeLoop && (converted[0][0] !== last[0] || converted[0][1] !== last[1])) {
        converted.push(converted[0]);
    }
    return converted;
};
/**
 * Convert turf logic to lat/lng json
 */
EffluentSpreaderHelper.convertTurfToPosition = (p) => {
    let points = EffluentSpreaderHelper.reformatTurf(p);
    let converted = points.map((point) => {
        return {
            lat: point[1],
            lng: point[0],
        };
    });
    return converted;
};
/**
 * Get boundary made from a list of positions
 * @param range must be positive otherwise will return undefined
 */
EffluentSpreaderHelper.getLineBoundaries = (points, range) => {
    if (points.length === 0 || range < 0) {
        return undefined;
    }
    else if (points.length === 1) {
        return EffluentSpreaderHelper.getPointBoundaries(points[0], range);
    }
    let converted = EffluentSpreaderHelper.convertPositionToTurf(points);
    let line = (0, helpers_1.lineString)(converted, { name: 'meters' });
    // is confirmed as buffer fails only when range is negative (enough)
    let buffered = (0, turf_1.buffer)(line, range, { units: 'meters' });
    return EffluentSpreaderHelper.createArea(buffered.geometry.coordinates);
};
/**
 * Get area off a point
 * */
EffluentSpreaderHelper.getPointBoundaries = (points, range) => {
    if (range < 0) {
        throw new Error('getPointBoundaries:Invalid range - ' + range);
    }
    let converted = EffluentSpreaderHelper.convertPositionToTurf([points])[0];
    let p = (0, helpers_1.point)(converted);
    let buffered = (0, turf_1.buffer)(p, range, { units: 'meters' });
    // let bufferPoint = convertTurfToPosition(buffered.geometry.coordinates[0]);
    return buffered;
};
/**
 * Convert a list of points into an area
 * Might not actually need this
 * FIRST POSITION MUST MATCH LAST. (Code checks if matching. If not, pushes position to match)
 */
EffluentSpreaderHelper.createArea = (pointList) => {
    let first = pointList[0][0];
    let last = pointList[0][pointList[0].length - 1];
    let matched = first[0] === last[0] && first[1] === last[1];
    if (!matched) {
        pointList[0].push(first);
    }
    let p = (0, helpers_1.polygon)(pointList);
    return p;
};
/**Merge areas into one multipoly */
EffluentSpreaderHelper.mergeAreas = (areas) => {
    if (areas.length === 0) {
        return null;
    }
    else if (areas.length === 1) {
        return areas[0];
    }
    let areaCopy = [...areas];
    let combiner = areaCopy.shift();
    do {
        let u = (0, turf_1.union)((0, helpers_1.featureCollection)([combiner, areaCopy.shift()]));
        combiner = u;
    } while (areaCopy.length > 0);
    return combiner;
};
/**
 * Wrapper to get the area (m^2) of a polygon
 */
EffluentSpreaderHelper.getAreaMeter = (a) => {
    return (0, turf_1.area)(a);
};
EffluentSpreaderHelper.overlapArea = (area1, area2) => {
    let area1Convert;
    let area2Convert;
    // check if list of position
    if (Array.isArray(area1)) {
        area1Convert = EffluentSpreaderHelper.createArea([EffluentSpreaderHelper.convertPositionToTurf(area1)]);
    }
    else {
        area1Convert = area1;
    }
    if (Array.isArray(area2)) {
        area2Convert = EffluentSpreaderHelper.createArea([EffluentSpreaderHelper.convertPositionToTurf(area2)]);
    }
    else {
        area2Convert = area2;
    }
    let intersection = (0, turf_1.intersect)((0, helpers_1.featureCollection)([area1Convert, area2Convert]));
    if (intersection === null) {
        return 0; // no area
    }
    let area = EffluentSpreaderHelper.getAreaMeter(intersection);
    return area;
};
EffluentSpreaderHelper.measuredDistance = (start, end) => {
    let startConvert = [start.lng, start.lat];
    let endConvert = [end.lng, end.lat];
    let d = (0, turf_1.distance)(startConvert, endConvert, { units: 'meters' });
    return d;
};
EffluentSpreaderHelper.parseLocationOutliers = (position, maxDistance) => {
    if (position.length < 3) {
        return position;
    }
    let distance = position
        .map((val, index) => {
        if (position[index + 1] === undefined) {
            return undefined;
        }
        else {
            let distance = EffluentSpreaderHelper.findDistance(val, position[index + 1]);
            return distance;
        }
    })
        .filter((val) => val !== undefined);
    let average = distance.reduce((acc, cur) => {
        acc += cur;
        return acc;
    }, 0) / distance.length;
    let limiter = maxDistance || average;
    // find indicies where average is above
    let parsedRes = [position[0]];
    let skips = 0;
    position.forEach((place, i) => {
        if (i !== 0) {
            let distance = EffluentSpreaderHelper.findDistance(parsedRes[parsedRes.length - 1], place);
            if (distance <= limiter * (skips + 1) * EffluentSpreaderHelper.DISTANCE_PADDING_FACTOR) {
                parsedRes.push(place);
                skips = 0;
            }
            else {
                skips++;
            }
        }
    });
    return parsedRes;
};
EffluentSpreaderHelper.getExpectedRunLine = (tracker, eachRun) => {
    if (eachRun.length < 1) {
        return undefined;
    }
    let currentLocations = (tracker.path || []);
    const turfedCurrentLocations = EffluentSpreaderHelper.convertPositionToTurf(currentLocations).map((tf) => (0, helpers_1.point)(tf));
    // pointToLineDistance
    let runScore = eachRun
        .map((run) => {
        let runPoint = run.path;
        let turfedRun;
        if (run.pathType === Definitions_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader && (runPoint === null || runPoint === void 0 ? void 0 : runPoint.length) === 1) {
            // construct line
            let potentialPoints = (0, turf_1.circle)(EffluentSpreaderHelper.convertPositionToTurf(runPoint)[0], run.radius, { units: 'meters' }).geometry.coordinates[0];
            turfedRun = (0, helpers_1.lineString)(potentialPoints);
        }
        else {
            turfedRun = (0, helpers_1.lineString)(EffluentSpreaderHelper.convertPositionToTurf(runPoint || []));
        }
        let distance = turfedCurrentLocations.reduce((acc, cur) => {
            let dis = (0, turf_1.pointToLineDistance)(cur, turfedRun, { units: 'meters' });
            acc += dis;
            return acc;
        }, 0);
        return {
            distance,
            average: distance / (currentLocations.length || 1),
            run,
        };
    })
        .sort((a, b) => a.distance - b.distance);
    // console.log(
    //   'runScore',
    //   runScore.map((val) => {
    //     return {
    //       name: val.run.name,
    //       distance: val.distance,
    //     };
    //   })
    // );
    return runScore[0];
};
EffluentSpreaderHelper.getMappedRunPath = (current, run) => {
    let line = EffluentSpreaderHelper.convertPositionToTurf(run);
    if (line.length < 2) {
        return current;
    }
    let lineStr = (0, helpers_1.lineString)(line);
    let currentTf = EffluentSpreaderHelper.convertPositionToTurf(current).map((pos) => (0, helpers_1.point)(pos));
    // new converts all. Will mostly be a straight line except for pivot runs
    let nearestAll = currentTf.map((tfPoint) => (0, turf_1.nearestPointOnLine)(lineStr, tfPoint).geometry.coordinates);
    // if the first and last is the same (except length one, delete the end so it doesnt loop back)
    if (nearestAll.length > 1) {
        const first = nearestAll[0];
        const last = nearestAll.at(-1);
        if (last && first[0] === last[0] && first[1] === last[1]) {
            nearestAll.pop();
        }
    }
    return EffluentSpreaderHelper.convertTurfToPosition(nearestAll);
};
/**
 * Finds the distance between two locations.
 * @param from
 * @param to
 * @returns the distance between the two points (meters)
 */
EffluentSpreaderHelper.findDistance = (from, to) => {
    let convertedStart;
    let convertedEnd;
    if (Array.isArray(from)) {
        convertedStart = from;
    }
    else {
        convertedStart = EffluentSpreaderHelper.convertPositionToTurf([from])[0];
    }
    if (Array.isArray(to)) {
        convertedEnd = to;
    }
    else {
        convertedEnd = EffluentSpreaderHelper.convertPositionToTurf([to])[0];
    }
    let distanceBetween = (0, turf_1.distance)(convertedStart, convertedEnd, {
        units: 'meters',
    });
    return distanceBetween;
};
EffluentSpreaderHelper.reformatTurf = (param) => {
    if (Array.isArray(param)) {
        if (param.every((element) => !Array.isArray(element))) {
            return [param];
        }
        else if (param.every((element) => Array.isArray(element) && element.every((inner) => !Array.isArray(inner)))) {
            return param;
        }
        else if (param.every((element) => Array.isArray(element) && element.every((inner) => Array.isArray(inner)))) {
            if (param.length === 1) {
                return param[0];
            }
        }
    }
    throw new Error('levelCheck: Invalid Format Detected - ' + JSON.stringify(param));
};
/**
 * @deprecated Delete if it is confirmed
 * @param effluentTracker
 * @param allRuns
 */
EffluentSpreaderHelper.mapPathToRun = (effluentTracker, allRuns) => {
    if (effluentTracker.path && effluentTracker.throwDistance) {
        effluentTracker.filteredPath = EffluentSpreaderHelper.parseLocationOutliers(effluentTracker.path);
        let expectedPathObj = EffluentSpreaderHelper.getExpectedRunLine(effluentTracker, allRuns);
        let expectedPath = expectedPathObj === null || expectedPathObj === void 0 ? void 0 : expectedPathObj.run;
        if (expectedPathObj && expectedPathObj.distance !== undefined && expectedPath && expectedPath.path) {
            let line = expectedPath.path;
            // is a pivot type
            if (line.length === 1 && expectedPath.radius) {
                line = EffluentSpreaderHelper.convertPointToCircle(line[0], expectedPath.radius);
            }
            let coveragePoints = EffluentSpreaderHelper.getMappedRunPath(effluentTracker.path, line);
            // let comparator = 0;
            switch (expectedPath.pathType) {
                case Definitions_1.EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                    // using gun dimensions
                    let remapped = (0, effluentAreaCalculation_1.covertLateralPathToArea)([coveragePoints[0], coveragePoints[coveragePoints.length - 1]], effluentTracker.throwDistance, expectedPath.radius, expectedPath);
                    // using path dimensions
                    // let remapped = covertLateralPathToArea(
                    //   [coveragePoints[0], coveragePoints[coveragePoints.length - 1]],
                    //   expectedPath.throwDistance,
                    //   expectedPath.radius,
                    //   expectedPath,
                    // );
                    if (remapped) {
                        coveragePoints = remapped;
                    }
                    break;
                case Definitions_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                    // using gun dimensions
                    if (effluentTracker.throwDistance && expectedPath.radius && expectedPath.path.length === 1 && expectedPath.coverage) {
                        coveragePoints = EffluentSpreaderHelper.mapCircleRun(coveragePoints, expectedPath.path[0], expectedPath.throwDistance + expectedPath.radius, expectedPath.coverage, expectedPath.throwDistance);
                    }
                    // using path dimensions
                    // if (
                    //   expectedPath.throwDistance &&
                    //   expectedPath.radius &&
                    //   expectedPath.path.length === 1 &&
                    //   expectedPath.coverage
                    // ) {
                    //   coveragePoints = mapCircleRun(
                    //     coveragePoints,
                    //     expectedPath.path[0],
                    //     expectedPath.throwDistance + expectedPath.radius,
                    //     expectedPath.coverage,
                    //     expectedPath.throwDistance,
                    //   );
                    // }
                    break;
                default:
                    // do throw around the line
                    let genericCoverageArea = (0, effluentAreaCalculation_1.convertLineTypePathToArea)(coveragePoints, effluentTracker.throwDistance);
                    if (genericCoverageArea) {
                        coveragePoints = genericCoverageArea;
                    }
            }
            // let turfedLine = lineString(convertPositionToTurf(linearLine));
            // let closestStartPoint = nearestPointOnLine(turfedLine, point([linearLine[0].lng, linearLine[0].lat]), { units: 'meters' }).geometry.coordinates;
            // let closestEndPoint = nearestPointOnLine(turfedLine, point([linearLine[linearLine.length - 1].lng, linearLine[linearLine.length - 1].lat]), { units: 'meters' }).geometry.coordinates;
            // let startDiff = findDistance(effluentTracker.filteredPath[0], closestStartPoint);
            // let endDiff = findDistance(effluentTracker.filteredPath[effluentTracker.filteredPath.length - 1], closestEndPoint);
            let max = expectedPathObj.run.throwDistance + expectedPathObj.run.radius;
            if (expectedPathObj.average < max * 1.2) {
                effluentTracker.mappedRun = expectedPath.pk;
                effluentTracker.mappedPath = coveragePoints;
                effluentTracker.runDifference = expectedPathObj.distance;
            }
            else {
            }
        }
    }
};
EffluentSpreaderHelper.getCircleIntersects = (point1, point2, radius1, radius2) => {
    let options = {
        steps: 25,
        units: 'meters',
    };
    let circle1 = (0, helpers_1.lineString)((0, turf_1.circle)((0, datamodel_core_1.gPointToTPosition)(point1), radius1, options).geometry.coordinates[0]);
    let circle2 = (0, helpers_1.lineString)((0, turf_1.circle)((0, datamodel_core_1.gPointToTPosition)(point2), radius2, options).geometry.coordinates[0]);
    let intersects = (0, turf_1.lineIntersect)(circle1, circle2).features.map((feature) => feature.geometry.coordinates);
    return intersects;
};
/**
 * Map Area on a single point
 */
EffluentSpreaderHelper.mapCircleRun = (inputPoints, center, radius, coverage, sprinklerRadius) => {
    // create sector
    let points = inputPoints;
    let turfed = EffluentSpreaderHelper.convertPositionToTurf(points);
    let middle = [center.lng, center.lat];
    let middleTurfed = (0, helpers_1.point)(middle);
    let north = [center.lng, center.lat + 1];
    let start = turfed[0];
    let end = turfed[turfed.length - 1];
    if (turfed.length === 1) {
        // if (start[0] === end[0] && start[1] === end[1]) {
        let intersectionPoints = EffluentSpreaderHelper.getCircleIntersects(center, inputPoints[0], radius, sprinklerRadius);
        if (intersectionPoints.length === 2) {
            start = intersectionPoints[0];
            end = intersectionPoints[1];
            turfed = intersectionPoints;
        }
        else {
            let pointArea = EffluentSpreaderHelper.getPointBoundaries(points[0], sprinklerRadius);
            return EffluentSpreaderHelper.convertTurfToPosition(pointArea.geometry.coordinates[0]);
        }
    }
    let angleFactor = EffluentSpreaderHelper.getAngleCalculation(north, middle, start);
    let bearing1 = 0;
    let bearing2 = 0;
    const pointAngles = turfed.map((turfPopint) => EffluentSpreaderHelper.toNorth(EffluentSpreaderHelper.getAngleCalculation(north, middle, turfPopint), angleFactor));
    let minMax = EffluentSpreaderHelper.getCircularExtremes(pointAngles);
    bearing1 = (minMax.min + angleFactor) % 360;
    bearing2 = (minMax.max + angleFactor) % 360;
    let sectorArea = (0, turf_1.sector)(middleTurfed, radius + sprinklerRadius, bearing1, bearing2, {
        units: 'meters',
    });
    let turfedCoverage = EffluentSpreaderHelper.convertPositionToTurf(coverage);
    let overlap = (0, turf_1.intersect)((0, helpers_1.featureCollection)([(0, helpers_1.polygon)([turfedCoverage]), sectorArea]));
    let plainCoords = overlap === null || overlap === void 0 ? void 0 : overlap.geometry.coordinates[0];
    if (overlap && plainCoords) {
        let toPosition = EffluentSpreaderHelper.convertTurfToPosition(plainCoords);
        return toPosition;
    }
    //failed
    return coverage;
};
EffluentSpreaderHelper.mapCirclePoints = (points, center, radius, sprinklerRadius) => {
    // create sector
    const middle = [center.lng, center.lat];
    let apparentRadius = radius;
    if (radius === sprinklerRadius) {
        apparentRadius = radius + sprinklerRadius;
    }
    const circleLineTf = (0, turf_1.circle)(middle, apparentRadius, {
        units: 'meters',
    }).geometry.coordinates[0];
    const circleLine = EffluentSpreaderHelper.convertTurfToPosition(circleLineTf);
    return EffluentSpreaderHelper.getMappedRunPath(points, circleLine);
};
EffluentSpreaderHelper.getAngleCalculation = (start, middle, end) => {
    let raw = (0, turf_1.angle)(start, middle, end);
    // WARNING. Need to comment out after lws update
    // if (booleanClockwise([start, middle, end, start]) === true) {
    //   return 360 - raw;
    // }
    return raw;
};
EffluentSpreaderHelper.convertPointToCircle = (center, radius) => {
    let circleLine = (0, turf_1.circle)([center.lng, center.lat], radius, {
        units: 'meters',
    }).geometry.coordinates[0];
    return EffluentSpreaderHelper.convertTurfToPosition(circleLine);
};
EffluentSpreaderHelper.getMidpointBetweenTwoPoints = (point1, point2) => {
    let midding = (0, turf_1.midpoint)(point1, point2).geometry.coordinates;
    return midding;
};
EffluentSpreaderHelper.convertMidLineForLateral = (rawLine) => {
    if (rawLine.length === 4 || rawLine.length === 5) {
        let filterOut = rawLine.slice(0, 4);
        let turfed = EffluentSpreaderHelper.convertPositionToTurf(filterOut);
        // find the midpoint on the lines so that
        var line1 = (0, helpers_1.lineString)(turfed.slice(0, 2));
        var line2 = (0, helpers_1.lineString)(turfed.slice(1, 3));
        let pointed = turfed.map((tPoint) => (0, helpers_1.point)(tPoint));
        if ((0, turf_1.length)(line1) < (0, turf_1.length)(line2)) {
            // midpoint between 0,1 and 2,3
            let midpointTurfed = [
                EffluentSpreaderHelper.getMidpointBetweenTwoPoints(pointed[0], pointed[1]),
                EffluentSpreaderHelper.getMidpointBetweenTwoPoints(pointed[2], pointed[3]),
            ];
            return EffluentSpreaderHelper.convertTurfToPosition(midpointTurfed);
        }
        else {
            // midpoint between 1,2 and 0,3
            let midpointTurfed = [
                EffluentSpreaderHelper.getMidpointBetweenTwoPoints(pointed[1], pointed[2]),
                EffluentSpreaderHelper.getMidpointBetweenTwoPoints(pointed[3], pointed[0]),
            ];
            return EffluentSpreaderHelper.convertTurfToPosition(midpointTurfed);
        }
    }
    else if (rawLine.length > 6) {
        // break method
        return undefined;
    }
    return rawLine;
};
EffluentSpreaderHelper.getCircularExtremes = (angles) => {
    const SEGMENT_SIZES = 10; // 6
    const SEGMENTS = Math.round(360 / SEGMENT_SIZES);
    let sectorSegments = Array(SEGMENTS).fill(0);
    sectorSegments[0] = 1;
    angles.forEach((val) => {
        let derivedIndex = Math.floor(val / SEGMENT_SIZES) % SEGMENTS;
        if (sectorSegments[derivedIndex] === 0) {
            sectorSegments[derivedIndex] = 1;
            if (sectorSegments.every((val) => val === 1)) {
                //do logic for a full circle
                return { min: 0, max: 360 };
            }
        }
    });
    // fill in random skips
    sectorSegments = sectorSegments.map((val, i) => {
        if (val === 0) {
            if (sectorSegments[(i + SEGMENTS - 1) % SEGMENTS] === 1 && sectorSegments[(i + SEGMENTS + 1) % SEGMENTS] === 1) {
                return 1;
            }
            return 0;
        }
        return 1;
    });
    // got indicies and length of zeros
    let zeroMapper = (0, exports.zeroMappers)(sectorSegments, SEGMENTS);
    let maxIndex = getKeyWithMaxValue(zeroMapper);
    const iterator = zeroMapper.keys();
    for (const value of iterator) {
        if (value !== maxIndex) {
            let updater = zeroMapper.get(value);
            if (updater) {
                for (let i = 0; i <= updater; i++) {
                    sectorSegments[(value + i) % SEGMENTS] = 1;
                }
            }
        }
    }
    // scan to find left and right extremes
    let positiveExtreme = sectorSegments.findIndex((val) => val === 0) - 1;
    let negativeExtreme = (SEGMENTS - sectorSegments.reverse().findIndex((val) => val === 0)) % SEGMENTS;
    // full circle
    let arr = [negativeExtreme, positiveExtreme];
    // console.log('arr', arr);
    // calculate range of min and max
    let minAngleRange = [arr[0] * SEGMENT_SIZES, (arr[0] + 1) * SEGMENT_SIZES];
    let maxAngleRange = [arr[1] * SEGMENT_SIZES, (arr[1] + 1) * SEGMENT_SIZES];
    // console.log('minAngleRange', minAngleRange);
    // console.log('maxAngleRange', maxAngleRange);
    let sorted = angles.sort();
    let min = sorted.find((val) => val >= minAngleRange[0] && val <= minAngleRange[1]) || 0;
    let max = sorted.reverse().find((val) => val >= maxAngleRange[0] && val <= maxAngleRange[1]) || 0;
    return { min, max };
};
EffluentSpreaderHelper.toNorth = (angle, angleFactor) => {
    return (angle - angleFactor + 360) % 360;
};
EffluentSpreaderHelper.findLineByLeastSquares = (values_x, values_y) => {
    var x_sum = 0;
    var y_sum = 0;
    var xy_sum = 0;
    var xx_sum = 0;
    var count = 0;
    /*
     * The above is just for quick access, makes the program faster
     */
    var x = 0;
    var y = 0;
    var values_length = values_x.length;
    if (values_length != values_y.length) {
        throw new Error('The parameters values_x and values_y need to have same size!');
    }
    /*
     * Above and below cover edge cases
     */
    if (values_length === 0) {
        return null;
    }
    /*
     * Calculate the sum for each of the parts necessary.
     */
    for (let i = 0; i < values_length; i++) {
        x = values_x[i];
        y = values_y[i];
        x_sum += x;
        y_sum += y;
        xx_sum += x * x;
        xy_sum += x * y;
        count++;
    }
    /*
     * Calculate m and b for the line equation:
     * y = x * m + b
     */
    const denominator = count * xx_sum - x_sum * x_sum;
    if (denominator === 0) {
        return null;
    }
    var gradiant = (count * xy_sum - x_sum * y_sum) / denominator;
    var intercept = y_sum / count - (gradiant * x_sum) / count;
    /*
     * We then return the x and y data points according to our fit
     */
    var result_values_x = [];
    var result_values_y = [];
    for (let i = 0; i < values_length; i++) {
        x = values_x[i];
        y = x * gradiant + intercept;
        result_values_x.push(x);
        result_values_y.push(y);
    }
    const forLoggin = result_values_x.map((val, i) => {
        return { lat: val, lng: result_values_y[i] };
    });
    return forLoggin;
};
EffluentSpreaderHelper.findLineByFirstLast = (values) => {
    let first = values[0];
    let last = values[values.length - 1];
    return [first, last];
};
